import ReactTable from './react-table';

export default ReactTable;
